import { FlagModel, ValueModel } from '@zajno/common-mobx/viewModels';
import { AppController } from 'app/controllers';
import { CampaignStatus } from 'common/types/models/campaign';
import { computed, makeObservable } from 'mobx';

export class CampaignViewModel {
    private _campaignId: string;

    private readonly _updateStatusFlag = new FlagModel(false);
    private readonly _newCampaignStatus = new ValueModel<CampaignStatus | null>(null);

    constructor(id: string) {
        makeObservable(this, {
            campaign: computed,
        });
        this._campaignId = id;
    }

    get isLoading() { return AppController.Instance.Campaigns.isLoading; }

    get campaign() { return AppController.Instance.Campaigns.repo.getCampaignDeferred(this._campaignId).current; }
    get isUpdateModalActive() { return this._updateStatusFlag.value; }
    get newCampaignStatus() { return this._newCampaignStatus.value; }

    get id () { return this.campaign?.id; }
    get status() { return this.campaign?.status; }
    get orderNumber() { return this.campaign?.seq_counter; }
    get customerEmail() { return this.campaign?.email; }
    get createAt() { return this.campaign?.created_at; }
    get playlists() { return this.campaign?.playlists?.links; }

    get slug () {
        return this.campaign?.product?.slug || this.campaign?.productRef?.slug;
    }
    get plan() {
        return this.campaign?.product?.name || this.campaign?.productRef?.name;
    }
    get streams() {
        return this.campaign?.product?.meta.guaranteedStream || this.campaign?.productRef?.meta.guaranteedStream;
    }

    get purchaseDate() {
        return this.campaign?.purchase?.created_at || this.campaign?.purchaseRef.created_at;
    }
    get authorName() {
        return this.campaign?.purchase?.input_data.authorName || this.campaign?.purchaseRef?.input_data.authorName;
    }
    get assetName() {
        return this.campaign?.purchase?.input_data?.assetName || this.campaign?.purchaseRef?.input_data.assetName;
    }
    get releaseDate() {
        return this.campaign?.purchase?.input_data.releaseDate || this.campaign?.purchaseRef?.input_data.releaseDate;
    }
    get customerName() {
        return this.campaign?.purchase?.input_data.username || this.campaign?.purchaseRef?.input_data.username;
    }
    get assetLink() {
        return this.campaign?.purchase?.input_data.assetLink || this.campaign?.purchaseRef?.input_data.assetLink;
    }

    public openUpdateStatusModal = (status: CampaignStatus) => {
        this._newCampaignStatus.setValue(status);
        this._updateStatusFlag.setTrue();
    };

    public closeUpdateStatusModal = () => {
        this._updateStatusFlag.setFalse();
    };

    public onUpdateStatus = async () => {
        await AppController.Instance.Campaigns.setStatus(this._campaignId, this._newCampaignStatus.value);

        this._updateStatusFlag.setFalse();
    };
}
